import { type UseMutationOptions, useMutation } from "@tanstack/react-query";
import type { Cart } from "@/features/cart/types/cart.type";
import { CART_WRITE_SCOPE } from "./use-update-cart";

type RemoveFromCartPayload = {
  cartId?: string;
  itemId: string;
};

type RemoveFromCartResponse = {
  cartId: string;
  cart: Cart;
};

export const useRemoveFromCart = (
  options?: Omit<
    UseMutationOptions<RemoveFromCartResponse, Error, RemoveFromCartPayload>,
    "mutationFn"
  >,
) => {
  return useMutation({
    scope: { id: CART_WRITE_SCOPE },
    mutationFn: async ({ cartId, itemId }: RemoveFromCartPayload) => {
      const response = await fetch("/api/cart/remove", {
        method: "POST",
        body: JSON.stringify({ cartId, itemId, type: "diet" }),
        keepalive: true,
      });

      if (!response.ok) {
        throw new Error("Failed to remove from cart");
      }

      return (await response.json()) as RemoveFromCartResponse;
    },
    ...options,
  });
};
